import { Component } from 'react';
import Icon from 'noc/components/icon';

function filteredData(tabsData, requestForId, getFilteredData, filterName, toggle, columnFilters) {
    getFilteredData(tabsData, requestForId);
    toggle(columnFilters, filterName);
}

class TextBoxFilter extends Component {
    constructor(props) {
        super(props);
        this.updateSearch = this.updateSearch.bind(this);
    }

    render() {
        const {
        requestForId,
        tabsData,
        filterName,
        isFilter,
        columnFilters
    } = this.props;

        const tabData = tabsData.find(x => x.Id === requestForId);
        let cols = [];
        let filter;
        const isShow = columnFilters.find(x => x.eventName === filterName).isStatus;
        const style = isShow ? '' : 'none';

        if (!isFilter) {
            cols = tabData.QueueViewGrid.Columns;
        } else {
            filter = tabData.QueueViewGrid.GridFilters.find(x => x.FilterName === filterName);
            cols = filter.FilterData;
        }

        const classNameOnFilterName = cols.length < 10 ? 'cn-filter__menu' : 'cn-filter__menu noc-filter__menu';

        return (
            <div
                className={classNameOnFilterName}
                style={{
                    display: style
                }}
                id={filterName}
            >
                <ul>
                    <li>
                        <label className="cn-field cn-field--search">
                            <span className="cn-field__label a11y">Search</span>
                            <input
                                className="cn-field__searchinput"
                                ref="search"
                                type="textbox"
                                placeholder="Type exact Queue name"
                                onKeyPress={this.updateSearch}
                            />
                            <Icon type="cn-field__icon" icon="icon-search" onClick={this.updateSearch} />
                        </label>
                    </li>
                </ul>
            </div>
        );
    }


    updateSearch(e) {
        const {
        getFilteredData,
        requestForId,
        tabsData,
        filterName,
        isFilter,
        columnFilters,
        toggle,
        onTextFilter
    } = this.props;

        // const tabData = tabsData.find(x => x.Id === requestForId);
        // const filter = tabData.QueueViewGrid.GridFilters.find(x => x.FilterName === filterName);
        const inputValue = this.refs.search.value;
        if (e.charCode === 13 || e.charCode === undefined) {
            onTextFilter(tabsData, requestForId, inputValue, true, isFilter, filterName, true);
            filteredData(tabsData, requestForId, getFilteredData, filterName, toggle, columnFilters);
            this.refs.search.blur();
            this.refs.search.value = '';
        }
    }
}

export default TextBoxFilter;



// WEBPACK FOOTER //
// ./app/components/text-box-filter.jsx